import { Formik, FormikHelpers } from "formik";
import { useFormSubmit } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { DisplayCancelLicenseForm } from "./DisplayCancelLicenseForm";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { CancelLicenseActionButton } from "../CancelLicenseButton";
import { useState } from "react";

import * as Yup from "yup";

export type SubmitAction = "cancel";

type CancelLicenseFormValueType = {
  licenseSerialNumberToCancel: string;
  CancellationReason: string;
  licenseProductCode: string;
  subCancelledDate?: Date | null;
};

type CancelLicenseFormProps = {
  licenseSerialNumberToCancel: string;
  licenseProductCode: string;
  referenceDrawer: DrawerType;
  onCloseDrawer: () => void;
};

export const CancelLicenseForm: React.FC<CancelLicenseFormProps> = ({
  licenseSerialNumberToCancel,
  licenseProductCode,
  referenceDrawer,
  onCloseDrawer,
}) => {
  const { t } = useTranslation();
  //const todayDateTime = dayjs().startOf("day").toDate();
  // const subCancelledDate = todayDateTime;
  const [CancellationReasonVar, setCancellationReasonVar] =
    useState<string>("");
  const [subCancelledDateVar, setSubCancelledDateVar] = useState<
    Date | undefined
  >(undefined);
  const [openAskConirmationBoxTrigger, setOpenAskConfirmationBoxTrigger] =
    useState(false);

  const onSubmit = async (
    values: CancelLicenseFormValueType,
    formikHelpers: FormikHelpers<CancelLicenseFormValueType>
  ) => {
    setCancellationReasonVar(values.CancellationReason);
    setSubCancelledDateVar(
      values?.subCancelledDate ? values.subCancelledDate : undefined
    );
    await onCancelSerialNumber(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const initialValues: CancelLicenseFormValueType = {
    licenseSerialNumberToCancel: licenseSerialNumberToCancel!,
    CancellationReason: "",
    licenseProductCode: licenseProductCode,
    subCancelledDate: undefined,
  };

  const handleCancelLicense = async (
    values: CancelLicenseFormValueType,
    formikHelpers: FormikHelpers<CancelLicenseFormValueType>,
    options: {}
  ) => {
    //const { licenseProductCode, licenseSerialNumberToCancel, CancellationReason } = values;
    setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger);
  };

  const formSubmitToCancelLicense = () => {
    return [
      async (
        values: CancelLicenseFormValueType,
        formikHelpers: FormikHelpers<CancelLicenseFormValueType>
      ) => {
        return handleCancelLicense(values, formikHelpers, {});
      },
      {
        translationPrefix: ["licenses.basic.detail.cancel", "title"].join("."),
        onError: () => {
          // refetch entity from server
          //  queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onCancelSerialNumber = useFormSubmit(...formSubmitToCancelLicense());

  const CancelLicenseSchema = Yup.object().shape({
    CancellationReason: Yup.string().required(
      t("licenses.basic.actions.cancel.required.reason")
    ),
  });

  console.log("Initial values ", JSON.stringify(initialValues));
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={CancelLicenseSchema}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayCancelLicenseForm
            licenseSerialNumberToCancel={licenseSerialNumberToCancel}
          />
        </DirtyFormPrompt>
      </Formik>
      {CancellationReasonVar !== "" && (
        <CancelLicenseActionButton
          cancelActionDetails={{
            licenseSerialNumberToCancel: licenseSerialNumberToCancel,
            licenseProductCode: licenseProductCode,
            CancellationReason: CancellationReasonVar,
            subCancelledDate: subCancelledDateVar,
          }}
          referencesDrawer={referenceDrawer}
          openAskConirmationBoxTrigger={openAskConirmationBoxTrigger}
          onCloseDrawer={onCloseDrawer}
        ></CancelLicenseActionButton>
      )}
    </>
  );
};
